import React from 'react'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router'
import * as routes from 'core/routing/constants/index'

const RedirectToRoute = props => {
  const { history, match } = props

  let url

  switch (match.params.id) {
    case '1':
      url = routes.TRADEIN
      break
    case '2':
      url = routes.REDIRECT_TO_CONFIGURATOR_FUNDING
      break

    case '3':
      url = routes.REDIRECT_TO_STOCK_FUNDING
      break
    case '4':
      url = routes.REDIRECT_TO_CONFIGURATOR_FINALIZATION
      break
    case '5':
      url = routes.REDIRECT_TO_STOCK_FINALIZATION
      break
    default:
      return false
  }

  history.push(url)

  return (
    <div>
      <h1>Redidrect to route</h1>
    </div>
  )
}

RedirectToRoute.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired
}

export default withRouter(RedirectToRoute)
